import Row from '@/components/ezuro/workschedule/components/Row.vue';

export default {
  name: 'OverviewRow',
  props: {
    user: {
      type: Object,
      default: null
    },
    departmentId: {
      type: Number
    },
    divisionId: {
      type: Number
    },
    scheduleData: {
      type: Object
    },
    mainType: {
      type: String,
      default: 'view'
    },
    showAllRows: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Row
  },
  data () {
    return {
      showRows: this.showAllRows
    }
  },
  computed: {
    recordsView () {
      const scheduleId = this.getScheduleId('view');
      const records = this.getRecords(scheduleId);

      return records;
    },
    recordsPlan () {
      const scheduleId = this.getScheduleId('plan');
      const records = this.getRecords(scheduleId);

      return records;
    },
    recordsTrack () {
      const scheduleId = this.getScheduleId('track');
      const records = this.getRecords(scheduleId);

      return records;
    },
    rows () {
      const data = [
        {
          type: 'track',
          records: this.recordsTrack
        },
        {
          type: 'view',
          records: this.recordsView
        },
        {
          type: 'plan',
          records: this.recordsPlan
        }
      ];

      return data.sort((a, b) => (a.type != this.mainType ? 1 : -1));
    }
  },
  methods: {
    editRecord: function (record) {
      this.$emit('editRecord', record);
    },
    addRecord: function (record) {
      this.$emit('editRecord', record);
    },
    filter () {
      this.$emit('filter');
    },
    toggleRow: function () {
      this.showRows = !this.showRows;
    },
    getScheduleId: function (type) {
      let scheduleId = null;

      for (const key in this.scheduleData.schedules) {
        if (
          this.scheduleData.schedules[key].department_id == this.departmentId &&
          this.scheduleData.schedules[key].division_id == this.divisionId &&
          this.scheduleData.schedules[key].type === type
        ) {
          scheduleId = this.scheduleData.schedules[key].id;
          break;
        }
      }

      return scheduleId;
    },
    getRecords: function (scheduleId) {
      const records = [];
      const userId = (this.user ? this.user.id : null);

      if (scheduleId) {
        for (const key in this.scheduleData.records) {
          if (this.scheduleData.records[key].schedule_id === scheduleId) {
            if (this.scheduleData.records[key].user_id == userId) {
              records.push(this.scheduleData.records[key]);
            }
          }
        }
      }

      return records;
    }
  },
  watch: {
    showAllRows: function (newVal) {
      this.showRows = newVal;
    }
  }
}
